import { render, staticRenderFns } from "./DashboardsBI.vue?vue&type=template&id=14f06754&scoped=true"
import script from "./DashboardsBI.vue?vue&type=script&lang=js"
export * from "./DashboardsBI.vue?vue&type=script&lang=js"
import style0 from "./DashboardsBI.vue?vue&type=style&index=0&id=14f06754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f06754",
  null
  
)

export default component.exports